<template>
  <div id="DetallesConsultaDireccion_div">
    <div id="TituloConsultaDireccion_div" class="w-100">
      <h1 style="margin-bottom: 0px;">Cédula de Expediente {{cedulaBD.Expediente.NumeroDeDocumento}}</h1>
     <!--  <h3 style="margin-top: 0px;">Detalles de cédula para juzgado</h3> -->
    </div>
     <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
      <div class="flex-grow-1"><button type="button" @click="regresarAVistaPrincipal" class="btn btn-primary"><i class="fas fa-long-arrow-alt-left" style="font-size:20px;"></i></button></div>
      <div class="flex-grow-1" style="padding-left: 11em;"><h4>Detalles de cédula</h4></div>
      <div class="flex-grow-1"></div>
    </div>
    <div id="contendor-detalles" class="col-12 area">
     <!--  <div class="form-inline">
        <button type="button" @click="regresarAVistaPrincipal" class="btn btn-primary mr-sm-3"><i class="fas fa-long-arrow-alt-left"></i></button>
        <h3>Detalles de cédula</h3>
      </div> -->
      <div class="d-flex justify-content-between mt-2">
        <div style="width: 29%">
          <div id="contenedor-inf-vdcjz" class="contenedor-color-negro">
            <InformacionBasicaDeCedula v-if="this.campoRequeridoEsValido(cedulaBD)"
              :titulo="'Información'" 
              :cedula="cedulaBD"
              :conInformacionDeJurisdiccion="true"
              :conDatosParaJuzgado="true"></InformacionBasicaDeCedula>
          </div>
        </div>  
        <div id="contenedro-visor-documento-vdcjz" class="contenedor-color-negro" style="width: 69%;">
          <div :class="[(this.campoRequeridoEsValido(cedulaBD.ArchivoRuta)) ? 'd-flex justify-content-between align-items-center mb-2' : 'd-flex']">
            <h5 class="mb-3">Documento </h5>
            <button v-if="this.campoRequeridoEsValido(cedulaBD.ArchivoRuta)" @click="descargarDocumentoDeCedula({ rutaDelArchivo: cedulaBD.ArchivoRuta })" type="button" class="btn btn-success">Descargar documento</button>
          </div>
          <PDFDocument :url="cedulaBD.ArchivoRuta" :height="heightVisor"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import sistemas from '@/../static/js/sistemas'
  import PDFDocument from '@/../src/components/Comunes/PDFDocument'
  import router from '@/router/index'
    import api from '@/../static/js/api'

   export default {
    components: {
      InformacionBasicaDeCedula: sistemas.SINOJ.CInformacionBasicaDeCedula,
      PDFDocument
    },
   data() {
      return {  
        cedulaBD: null,
        filtrosPreviosVistaPadre: null,
        heightVisor: 100
      }
    },
    methods: {
      regresarAVistaPrincipal: function() {
        let tieneFiltroPrevios = Object.values(this.filtrosPreviosVistaPadre).some(f => this.campoRequeridoEsValido(f));
        this.filtrosPreviosVistaPadre.cargarConFiltros = tieneFiltroPrevios;
        router.push({ name: "ConsultaJuzgado", params: { filtrosParaCargar: this.filtrosPreviosVistaPadre } });
      },
      descargarDocumentoDeCedula: function({ rutaDelArchivo }) { 
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${ rutaDelArchivo }`
          a.click();
      },
      campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      }
    },
    mounted() {
      if(this.campoRequeridoEsValido(this.cedulaBD.ArchivoRuta)) {
        this.heightVisor = $('#contenedor-inf-vdcjz').height() - 40 + 'px';
      }
      else {
        $('#contenedro-visor-documento-vdcjz').height(100)
      }
    },
    created() {
      const PARAMETROS_VISTA = router.history.current.params;
        if(!this.campoRequeridoEsValido(PARAMETROS_VISTA.cedula) || !this.campoRequeridoEsValido(PARAMETROS_VISTA.filtrosPrevios)) {
            router.push({ name: "ConsultaJuzgado"});
        }
        else {
            this.cedulaBD = PARAMETROS_VISTA.cedula;
            this.filtrosPreviosVistaPadre = PARAMETROS_VISTA.filtrosPrevios;
        }
    }
  }
</script>
<style scoped>
.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

#encabezado-contenedor-contenido {
    background-color: rgb(44, 43, 43);
    padding: 10px;
  }

  #encabezado-contenedor-contenido .btn {
    background-color: black;
    padding-left: 15px;
    padding-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Consultas/ConsultaJuzgado/DetallesCedula.vue